/* Recherche : suggestions de produits et de collections pendant la frappe */
(function () {
  var forms = document.querySelectorAll('[data-tk-search]');
  if (!forms.length) return;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(v) { var n = parseFloat(v); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }

  [].forEach.call(forms, function (form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-tk-suggest]');
    var pop = form.querySelector('[data-tk-pop]');
    var timer, ctrl;

    function open() { box.hidden = false; form.classList.add('is-open'); }
    function close() { box.hidden = true; form.classList.remove('is-open'); }
    function showPop() { box.innerHTML = pop ? pop.innerHTML : ''; box.hidden = !box.innerHTML.trim(); if (!box.hidden) form.classList.add('is-open'); }

    function render(q) {
      q = q.trim();
      if (q.length < 2) { showPop(); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each';
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var res = (d && d.resources && d.resources.results) || {};
          var prods = res.products || [], cols = res.collections || [];
          var html = '';
          if (cols.length) {
            html += '<p class="tk-suggest__h">Collections</p><div class="tk-suggest__chips">';
            cols.slice(0, 4).forEach(function (c) { html += '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
            html += '</div>';
          }
          if (prods.length) {
            html += '<p class="tk-suggest__h">Produits</p><ul class="tk-suggest__list">';
            prods.forEach(function (p) {
              html += '<li><a href="' + esc(p.url) + '">' +
                (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="tk-suggest__ph"></span>') +
                '<span class="tk-suggest__t">' + esc(p.title) + '</span><span class="tk-suggest__p">' + eur(p.price) + '</span></a></li>';
            });
            html += '</ul>';
          }
          if (!cols.length && !prods.length) {
            html = '<p class="tk-suggest__none">Aucun résultat pour « ' + esc(q) + ' ».</p>';
            if (pop) html += pop.innerHTML;
          } else {
            html += '<a class="tk-suggest__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Voir tous les résultats pour « ' + esc(q) + ' »</a>';
          }
          box.innerHTML = html;
          open();
        })
        .catch(function () { /* requête annulée ou hors ligne : on ne change rien */ });
    }

    input.addEventListener('focus', function () { render(input.value); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { render(input.value); }, 180); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });
})();
